import { Privilege } from "gql/graphql";
import { ReactElement } from "react";
import { usePrivilege } from "./usePrivileges";

interface Props {
  children: ReactElement;
  privilege: Privilege;
  organizationId?: string;
}

export const PrivilegeWrapper = ({
  privilege,
  organizationId,
  children,
}: Props) => {
  const { hasPrivilege, loading } = usePrivilege(privilege, organizationId);

  if (loading) {
    return null;
  } else if (!loading && hasPrivilege) {
    return children;
  } else {
    return null;
  }
};
